import styled from "@emotion/styled";

const ResetButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space?.space8};
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes?.fontSize14};
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.tone.black};
  white-space: nowrap;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    color: ${({ theme }) => theme.colors?.tone.silver};
    cursor: not-allowed;
  }
`;

const ResetFiltersFooter = styled.div`
  position: sticky;
  bottom: 0;
  padding: 24px;
  max-height: 64px;
  background-color: ${({ theme }) => theme.colors?.tone.white};
  box-shadow: 0 -4px 8px 0 ${({ theme }) => theme.effects.overlay.black_10};
  margin: 0 -16px;
  display: flex;
  justify-content: center;
`;

export { ResetButton, ResetFiltersFooter };
